const ErrorBorder = require('utils/framework/hocs/withErrorBoundary/ErrorBorder/ErrorBorder');


module.exports = ErrorBorder;
